<template>
  <div class="user-role-component">
    <confirm-dialog
      v-model="showPopup"
      :selected="role"
      @confirmed="deleteRole"
    ></confirm-dialog>

    <div class="level">
      <div class="level-left">
        <div class="has-text-weight-bold">{{ value.name }}</div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            v-if="hasEdit"
            class="button is-text is-icon"
            @click="showEditPopup(value)"
          >
            <span class="icon-edit"></span>
          </button>

          <button
            v-if="hasDelete"
            class="button is-text is-icon"
            @click="showPopup = true"
          >
            <span class="icon-delete"></span>
          </button>
        </div>
      </div>
    </div>

    <div>{{ organization.name }}</div>
    <div>Access to: {{ accessTo }}</div>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  name: 'UserRole',
  components: {
    ConfirmDialog
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    userId: {
      type: Number,
      default: null
    },
    hasEdit: {
      type: Boolean,
      default: true
    },
    hasDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopup: false,
      role: {},
      organization: {},
      accessTo: ''
    };
  },
  computed: {},
  watch: {
    value() {
      if (this.value.organizationID) this.loadOrganization();
    }
  },
  mounted() {
    if (this.value.organizationID) this.loadOrganization();
  },
  methods: {
    loadOrganization() {
      this.organization = this.$store.getters['organizations/byId'](
        this.value.organizationID
      );

      this.accessTo = this.$store.getters['groups/byId'](
        this.value.groupID
      ).name;
    },
    showEditPopup(item) {
      this.$emit('edit', item);
    },
    deleteRole() {
      this.showPopup = false;
      this.$emit('deleted', this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-role-component {
  width: 100%;
  border-radius: $radius;
  padding: 2rem 1.8rem 2rem 3rem;
  position: relative;
  margin-bottom: 15px;

  .button {
    margin-left: 20px;
  }
}
</style>
